// extracted by mini-css-extract-plugin
module.exports = {"game":"game_game__2AhJd","header":"game_header__-0DAD","container":"game_container__IYomO"};